import { useQuery, gql, ApolloError } from '@apollo/client'
import { EmployeeDisplayTinyInfoByEmployeeIdQuery, EmployeeDisplayTinyInfoByEmployeeIdQueryVariables } from '../../../types'

const EMPLOYEE_DISPLAY_TINY = gql`
  query EmployeeDisplayTinyInfoByEmployeeId($id: HashedId!) {
    employeeDisplayTinyInfoByEmployeeId(id: $id) {
      id
      firstName
      lastName
      avatarUrl
    }
  }
`

export default (
  id: string | null | undefined,
): { data: EmployeeDisplayTinyInfoByEmployeeIdQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  if (!id) {
    return { data: undefined, error: undefined, loading: true }
  }
  const { data, error, loading } = useQuery<EmployeeDisplayTinyInfoByEmployeeIdQuery, EmployeeDisplayTinyInfoByEmployeeIdQueryVariables>(
    EMPLOYEE_DISPLAY_TINY,
    {
      variables: { id },
    },
  )

  return { data, error, loading }
}
